
/* ==========================================================================
   Jobs Search Form
   ========================================================================== */

if ($('.js-job-search-form').length) {
    $(document).on('click', '.js-jobs-submit', function () {
        let jobsSearchPage = $('.js-job-search-form').data('jobsearchpage');
        let search = $('.js-jobs-search-term').val();
        let location = $('#jobs-location').val();
        let worktype = $('#jobs-worktype').val();
        let expertise = $('#jobs-expertise').val();

        window.location.href = jobsSearchPage
            + '?search=' + encodeURIComponent(search)
            + '&location=' + encodeURIComponent(location)
            + '&worktype=' + encodeURIComponent(worktype)
            + '&expertise=' + encodeURIComponent(expertise);
    });
}

/* ==========================================================================
   Jobs Search
   ========================================================================== */

if ($('.js-jobs-results').length) {
    $(document).on('click', '.js-jobs-submit', function () { loadJobs() });
    $(document).on('click', '.js-jobs-results .js-pagination-link', function () { loadJobs($(this).data('page')) });

    function loadJobs(page = 1) {
        let search = $('.js-jobs-search-term').val();
        let location = $('#jobs-location').val();
        let worktype = $('#jobs-worktype').val();
        let expertise = $('#jobs-expertise').val();

        let url = new URL(window.location);
        if (page > 1) url.searchParams.set('page', page);
        if (search) url.searchParams.set('search', search);
        if (location) url.searchParams.set('location', location);
        if (worktype) url.searchParams.set('worktype', worktype);
        if (expertise) url.searchParams.set('expertise', expertise);
        window.history.pushState({}, '', url);

        $.ajax({
            url: '/umbraco/surface/Jobs/GetJobs',
            type: 'GET',
            traditional: true,
            data: {
                jobSearchPage: $('.js-jobs-results').data('jobsearch'),
                location: location,
                worktype: worktype,
                expertise: expertise,
                search: search,
                page: page,
                resultsPerPage: $('.js-jobs-results').data('resultsperpage')
            },
            success: function (response) {
                $('.js-jobs-results').html(response);
            }
        });
    }
}
